// checkbox-cell.renderer.ts
import { Component, computed, inject } from "@angular/core";
import { ColumnKey } from "@bitwarden/web-vault/app/models/types/earn.types";
import { EarnService } from "@bitwarden/web-vault/app/services/earn/earn.service";
import { EarnLookup } from "@bitwarden/web-vault/app/services/earn/lookup.service";
import { ICellRendererAngularComp } from "ag-grid-angular";
import type { ICellRendererParams } from "ag-grid-community";

type RowRendererParams = ICellRendererParams & {
  isToggleDisabled?: (rowId: string) => boolean;
};

@Component({
  selector: "app-checkbox-cell-renderer",
  templateUrl: "./checkbox.cell-renderer.html",
})
export class CheckboxCellRenderer implements ICellRendererAngularComp {
  private params!: RowRendererParams;
  earnService = inject(EarnService);
  earnLookup = inject(EarnLookup);
  rowId = "";
  disabled = false;

  isMasked = computed(() => {
    const lookupMask = this.earnLookup.lookupMask();
    const rowId = this.params.data?.id;
    return lookupMask.rows.has(rowId);
  });

  agInit(params: RowRendererParams): void {
    this.params = params;
    this.rowId = params.data?.id ?? "";
    this.sync();
  }

  refresh(params: RowRendererParams): boolean {
    this.params = params;
    this.rowId = params.data?.id ?? "";
    this.sync();
    return true;
  }

  private sync() {
    this.disabled = !!this.params.isToggleDisabled?.(this.rowId);
  }

  onToggle() {
    this.earnLookup.toggleRow(this.rowId);
  }
}
